class Title {
	constructor(config) {
		this.config = Object.assign({
			scope: '.animated-title'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((i, el) => {
			const $el = $(el);

			const html = this.#wrapWords($el[0]);
			$el.html(html);
		});

		this.observe();
	}

	#wrapWords(el) {
		return Array.from(el.childNodes).map(node => {
			// Plain tekst node
			if (node.nodeType === Node.TEXT_NODE) {
				return node.textContent.trim().split(/\s+/).filter(Boolean).map(word =>
					`<span class="word"><span class="word-inner">${word}</span></span>`
				).join(' ');
			}

			// Element node (strong, b, em, etc.)
			if (node.nodeType === Node.ELEMENT_NODE) {
				const inner = this.#wrapWords(node);
				return `<${node.tagName.toLowerCase()}>${inner}</${node.tagName.toLowerCase()}>`;
			}

			return '';
		}).join(' ');
	}

	observe() {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					$(entry.target).addClass('is-visible');
					observer.unobserve(entry.target); // maar 1x animeren
				}
			});
		}, {
			threshold: 0.2
		});

		this.$scope.each((i, el) => observer.observe(el));
	}
}

export default new Title;